import {useCallback, useState} from 'react';
import IconButton from "./IconButton/IconButton";
import clipboard from "../lib/clipboard";
import Icons from "./IconButton/Icons";


function CopyText(props: CopyTextProps) {
	const {useCodeStyle, text, label} = props;

	const [clicked, setClicked] = useState(false);
	const [error, setError] = useState(null);

	const innerText = useCodeStyle ? <code style={{fontSize: '90%', margin: 'auto 0'}}>{text}</code> : text;

	const doCopy = useCallback(() => {
		try {
			clipboard.copy('ID', text)

			setClicked(true);
			setError(false);
			setTimeout(() => setClicked(false), 1000);
		}
		catch (err) {
			setError(err.message);
		}
	}, [text]);

	return (
		<div style={{display: 'flex', flexDirection: 'row', flexWrap: 'nowrap', gap: '5px'}}>
			{label ? <label style={{fontWeight: 600}}>{label}</label> : null}
			{innerText}
			<IconButton type={Icons.COPY} size='small' onClick={doCopy} label={clicked ? 'Copied!' : null}/>
			{error}
		</div>
	);
}

export type CopyTextProps = {
	// The text to show
	text: string,

	// Should we use a <code> tag instead of normal text?
	useCodeStyle?: boolean,

	// Optional label
	label?: string
};
export default CopyText;